import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const HistoryHealt = ({ responses = {}, selectedHistory }) => {
  console.log("Respustas seleccionadas", responses);

  return (
    <Box>
      {selectedHistory === "trainn" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <Typography>Objetivo personal:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.objetivoEsp ?? "Sin respuesta"}
            </Typography>
          </Box>

          <Box>
            <Typography>Experiencia corriendo:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.tiempoCorr ?? 0}
            </Typography>
          </Box>
          <Box>
            <Typography>Tipo de entrenamiento:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.tipoEntrenamiento ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Distancia preferida:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.distanciasKm ?? 0}
            </Typography>
          </Box>
          <Box>
            <Typography>Pace:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.pace ?? "0:0"}
            </Typography>
          </Box>
        </Box>
      )}
      {selectedHistory === "nutrition" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <Typography>Aglún diagnóstico alimenticio:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.diagnosticoAlm ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Dieta:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.dietas ?? "Ninguna"}
            </Typography>
          </Box>

          <Box>
            <Typography>Comidas al día:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.comidasDiarias ?? 0}
            </Typography>
          </Box>
          <Box>
            <Typography>Suplementos:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.suplementos ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Consumo de Agua:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.consumoAgua ?? 0}
            </Typography>
          </Box>
          <Box>
            <Typography>Consumo de Alcohol:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.consumoAlch ?? "No"}
            </Typography>
          </Box>
        </Box>
      )}
      {selectedHistory === "psicology" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <Typography>Estrés diario:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.estresDiario ?? "Sin respuesta"}
            </Typography>
          </Box>

          <Box>
            <Typography>Motivación personal:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.motivacion ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Asiedad:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.ansiedad ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Manejo de la presión:</Typography>
            <Typography style={{ textAlign: "Sin respuesta" }}>
              {responses?.presionCom ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Horas de descanso:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.sueño ?? 0}
            </Typography>
          </Box>
          <Box>
            <Typography>Apoyo emocional:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.apoyoEmocional ?? "Sin respuesta"}
            </Typography>
          </Box>
        </Box>
      )}
      {selectedHistory === "physical" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <Typography>Últimas lesiones:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.lesiones ?? "Sin respuesta"}
            </Typography>
          </Box>

          <Box>
            <Typography>Molestias recientes:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.molestiasDolor ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Diagnóstico Ortopédico o Muscular:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.diagnosticoOrt ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>
              Realiza ejercicios de movimiento o estiramientos:
            </Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.ejerciciosMov ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Tipo de calzado que usa:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.calzado ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Sesiones previas de fisioterapia:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.sesionesDep ?? "Sin respuesta"}
            </Typography>
          </Box>
        </Box>
      )}
      {selectedHistory === "general" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <Typography>Altura (metros):</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.altura ?? "Sin respuesta"}
            </Typography>
          </Box>

          <Box>
            <Typography>Peso (kg):</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.peso ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>¿Padeces alguna enfermedad crónica?:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.enfermedadCronica ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>
              ¿Tienes antecedentes familiares de enfermedades relevantes?:
            </Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.antecedentesFam ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>
              ¿Has tenido alguna cirugía o intervención médica importante?:
            </Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.cirugiasImp ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>¿Tomas algún medicamento actualmente?:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.medicacionAct ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>
              ¿Tienes alergias conocidas? (Medicamentos, alimentos, etc.):
            </Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.alergiasCon ?? "Sin respuesta"}
            </Typography>
          </Box>
        </Box>
      )}
      {selectedHistory === "preferences" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <Typography>Horario preferido para entrenar:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.horario ?? "Sin respuesta"}
            </Typography>
          </Box>

          <Box>
            <Typography>Terreno preferido para entrenar:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.terreno ?? "Sin respuesta"}
            </Typography>
          </Box>
          <Box>
            <Typography>Distancia máxima recorrida:</Typography>
            <Typography style={{ textAlign: "center" }}>
              {responses?.distancia ?? "Sin respuesta"}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HistoryHealt;
